import type { ElementType, ComponentPropsWithoutRef, ReactNode } from 'react'

type SchemaElementProps<T extends ElementType> = {
  as?: T
  prop: string

  children?: ReactNode
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'itemProp'>

function SchemaElement<T extends ElementType = 'span'>(
  props: SchemaElementProps<T>
) {
  const { as, prop, children, ...rest } = props
  const Component = as || 'span'

  return (
    <Component
      itemProp={prop}
      {...rest}
    >
      {children}
    </Component>
  )
}

export default SchemaElement
